import { render } from "./ConvoDisplay.vue?vue&type=template&id=66f6ca01"
import script from "./ConvoDisplay.vue?vue&type=script&lang=js"
export * from "./ConvoDisplay.vue?vue&type=script&lang=js"

import "./ConvoDisplay.vue?vue&type=style&index=0&id=66f6ca01&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__